"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Icons_1 = require("./Icons");
const _1 = require(".");
const ListGroupItem = ({ children, deleteButton, onClick, onDelete }) => (React.createElement("div", { style: {
        display: 'flex',
        justifyContent: 'space-between',
    }, onClick: onClick },
    children,
    !!deleteButton ? (deleteButton) : (React.createElement(Icons_1.CircleCloseIcon, { fill: _1.silver, height: "24", width: "24", onClick: e => {
            e.stopPropagation();
            onDelete();
        } }))));
exports.default = ListGroupItem;
